import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://ad02f6df955c495851300763082e48a7@o278132.ingest.us.sentry.io/4509383363067904",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  integrations: [Sentry.browserTracingIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),
  ],
  tracesSampleRate: 1.0,
  _experiments: { enableLogs: true},
  // tracePropagationTargets: ["https://wetrackssl.com"],
  sendDefaultPii: true,
});



  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
